"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeTransitionVariants = void 0;
var makeTransitionVariants = function (_a) {
    var _b, _c, _d, _e;
    var enter = _a.enter, entering = _a.entering, entered = _a.entered, exit = _a.exit, exiting = _a.exiting, exited = _a.exited, unmounted = _a.unmounted;
    return ({
        entering: (_b = entering !== null && entering !== void 0 ? entering : enter) !== null && _b !== void 0 ? _b : {},
        entered: (_c = entered !== null && entered !== void 0 ? entered : enter) !== null && _c !== void 0 ? _c : {},
        exiting: (_d = exiting !== null && exiting !== void 0 ? exiting : exit) !== null && _d !== void 0 ? _d : {},
        exited: (_e = exited !== null && exited !== void 0 ? exited : exit) !== null && _e !== void 0 ? _e : {},
        unmounted: unmounted !== null && unmounted !== void 0 ? unmounted : {},
    });
};
exports.makeTransitionVariants = makeTransitionVariants;
